import { UrlHelper } from '@/gr/common/urlHelper';
import _ from 'lodash';

export class EmbedService {
  constructor(private _origin: string) {}

  getEmbedUrl(args: IEmbedContainerArgs): string {
    const url = UrlHelper.combine(this._origin, '/registrations/new');

    const defaults = {
      hostUrl: /global-roam.com/.test(document.referrer) ? undefined : document.referrer,
      contentUrl: window.location.href,
      sandboxed: true
    } as IEmbedContainerArgs;

    const argsWithDefaults = _.defaults({}, args, defaults);

    const query = _(argsWithDefaults)
      .map((value: string, key) => (value !== undefined ? `${key}=${encodeURIComponent(value)}` : null))
      .filter((x) => x != null)
      .join('&');

    return `${url}?${query}`;
  }
}

export interface IEmbedContainerArgs {
  name: string;
  contentUrl?: string;
  termsAndConditionsUrl?: string;
  sandboxed?: boolean;
  hostUrl?: string;
  style?: string;
}
